import { withPrefix } from 'gatsby';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html, body {
    max-width: 100%;
  }

  body {
    font-family: Worksans Variablefont Wght, sans-serif !important;
    font-weight: 500 !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    color: inherit;
  }
  @font-face {
      font-display: swap;
      font-family: 'Worksans Variablefont Wght';
      src: url(${withPrefix('/fonts/WorkSans-Thin.woff2')}) format('woff2'),
      url(${withPrefix('/fonts/WorkSans-Thin.woff')}) format('woff');
      font-weight: 100;
      font-style: normal;
  }

  @font-face {
      font-display: swap;
      font-family: 'Worksans Variablefont Wght';
      src: url(${withPrefix('/fonts/WorkSans-ExtraLight.woff2')}) format('woff2'),
      url(${withPrefix('/fonts/WorkSans-ExtraLight.woff')}) format('woff');
      font-weight: 200;
      font-style: normal;
  }

  @font-face {
      font-display: swap;
      font-family: 'Worksans Variablefont Wght';
      src: url(${withPrefix('/fonts/WorkSans-Light.woff2')}) format('woff2'),
      url(${withPrefix('/fonts/WorkSans-Light.woff')}) format('woff');
      font-weight: 300;
      font-style: normal;
  }

  @font-face {
      font-display: swap;
      font-family: 'Worksans Variablefont Wght';
      src: url(${withPrefix('/fonts/WorkSans-Regular.woff2')}) format('woff2'),
      url(${withPrefix('/fonts/WorkSans-Regular.woff')}) format('woff');
      font-weight: 400;
      font-style: normal;
  }

  @font-face {
      font-display: swap;
      font-family: 'Worksans Variablefont Wght';
      src: url(${withPrefix('/fonts/WorkSans-Medium.woff2')}) format('woff2'),
      url(${withPrefix('/fonts/WorkSans-Medium.woff')}) format('woff');
      font-weight: 500;
      font-style: normal;
  }

  @font-face {
      font-display: swap;
      font-family: 'Worksans Variablefont Wght';
      src: url(${withPrefix('/fonts/WorkSans-SemiBold.woff2')}) format('woff2'),
      url(${withPrefix('/fonts/WorkSans-SemiBold.woff')}) format('woff');
      font-weight: 600;
      font-style: normal;
  }

  @font-face {
      font-display: swap;
      font-family: 'Worksans Variablefont Wght';
      src: url(${withPrefix('/fonts/WorkSans-Bold.woff2')}) format('woff2'),
      url(${withPrefix('/fonts/WorkSans-Bold.woff')}) format('woff');
      font-weight: 700;
      font-style: normal;
  }

  @font-face {
      font-display: swap;
      font-family: 'Tusker Grotesk 6500';
      src: url(${withPrefix('/fonts/tusker-grotesk-6500-medium.woff2')}) format('woff2'),
      url(${withPrefix('/fonts/tusker-grotesk-6500-medium.woff')}) format('woff');
      font-weight: 500;
      font-style: normal;
  }

  @font-face {
      font-display: swap;
      font-family: 'Fa Solid 900';
      src: url(${withPrefix('/fonts/fa-solid-900.woff2')}) format('woff2'),
      url(${withPrefix('/fonts/fa-solid-900.woff')}) format('woff');
  }
`;

export default GlobalStyle;
